<div class="facets" [ngClass]="{show: showFacets }">
    <h3 class="dialog-title"><span class="dialog-title-link">Filter &amp; Sort</span>
        <a class="dialog-close" (click)="facetDialogClose($event)">
            <span class="sr-only">Close Dialog</span> <i class="fa fa-remove"></i>
        </a>
    </h3>
    <div class="facets-content">
        <h3 class="facets-title-main">Refine Results</h3>
        <div class="mobile-sort">
            <a class="mobile-sort-op" [ngClass]="{active: state.sort == 'ascending'}"
                (click)="sortChange('ascending')">Sort
                by A-Z</a>
            <a class="mobile-sort-op" [ngClass]="{active: state.sort == 'descending'}"
                (click)="sortChange('descending')">Sort
                by Z-A</a>
            <a class="mobile-sort-op" *ngIf="hasDistanceSort()" [ngClass]="{active: state.sort == 'distance'}"
                (click)="sortChange('distance')">Sort by Distance</a>
        </div>
        <div cdkTrapFocus [cdkTrapFocus]="locationOptionsVisible" class="facet-group facet-group-location"
            [ngClass]="{show: locationOptionsVisible}">
            <h4 class="facet-title">
                <a (click)="showLocationOptions($event)" class="dialog-title-link">Providers Near</a>
                <a class="dialog-back" (click)="locationsBack($event)"><span class="sr-only">Go back</span> ❮ </a>
                <a class="dialog-close" (click)="facetDialogClose($event)">
                    <span class="sr-only">Close Location options</span> <i class="fa fa-remove"></i>
                </a>
            </h4>
            <div class="facet-group-location-content">
                <div class="form-group form-group-location">
                    <label for="refineLocation" class="sr-only">Choose a location</label>
                    <input ngx-google-places-autocomplete [(ngModel)]="refineLocation" name="refineLocation"
                        [options]='placesOptions' placeholder="Address, city or zip" class="form-control"
                        #placesRef="ngx-places" (onAddressChange)="handleAddressChange($event)"
                        (keyup)="handleLocationKeyup($event)" />
                    <i class="fa fa-map-marker"></i>
                </div>
                <div class="form-group">
                    <label for="distance" class="sr-only">Within distance</label>
                    <select name="distance" [(ngModel)]="distance" (change)="distanceChanged($event)"
                        class="form-control">
                        <option value="">Within any distance</option>
                        <option value="5">5 miles</option>
                        <option value="10">10 miles</option>
                        <option value="15">15 miles</option>
                        <option value="25">25 miles</option>
                        <option value="50">50 miles</option>
                    </select>
                </div>
                <a *ngIf="hasGeolocation()" (click)="useMyLocationClick($event)" class="use-my-location"><i
                        class="fa fa-map-marker"></i> Use my current
                    location <i *ngIf="locationLookupLoading" class="fa fa-circle-o-notch fa-spin"></i></a>
            </div>
        </div>
        <wfbhsearch-facet *ngFor="let option of this.getFacetOptions()" [facet]="option" [lockFacet]="lockFacet">
        </wfbhsearch-facet>
    </div>
    <div class="dialog-footer">
        <a class="btn bordered show-results" (click)="facetDialogClose($event)">Show Results</a>
        <div class="row">
            <div class="col-xs-8">
                <a *ngIf="hasUnlockedFacet()" (click)="clearFacets($event)" class="clear-facets-link">Clear filters</a>
                <a (click)="resetSearch()" class="clear-facets-link">Reset search</a>
            </div>
            <div class="col-xs-4">
                <wfbhsearch-search-info>
                </wfbhsearch-search-info>
            </div>
        </div>
    </div>
</div>